import * as types from 'constants/actionTypes';
import * as Rx from 'rxjs';
const { Observable } = Rx;
const { of, ajax } = Observable;
import * as actions from 'actions/workOrderActions';
const apiUrls = require('constants/apiUrls');
import * as mouseFlowUtils from '../utils/mouseFlowUtils';
import { TAG_ADD_EQUIPMENT_OPTIONS } from '../constants/mouseFlow';
import { wowCustomHeader } from '../utils/wowCustomHeadersUtils';
import { getAccessTokenFromState } from 'utils/userManager';

export const indirect = {
  call: (fn, ...args) => fn(...args)
};

export const api = {

  addEquipmentOptions: (request, store) => {

    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    const wowHeaders = wowCustomHeader(state);

    mouseFlowUtils.setNewPageView(apiUrls.EQUIPMENT_OPTIONS_URL);
    mouseFlowUtils.setTag(TAG_ADD_EQUIPMENT_OPTIONS);

    return ajax({
      url: apiUrls.EQUIPMENT_OPTIONS_URL,
      method: 'POST',
      body: request,
      responseType: 'json',
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + accessToken,
        'Accept': 'application/json'
      }
    });
  }
};

export const addEquipmentOptionEpic = (action$, store, call = indirect.call) => action$
  .ofType(types.EQUIPMENT_OPTION_SUBMIT_STARTED)
  .mergeMap(action => call(api.addEquipmentOptions, action.request, store, action.orderId).map((payload) => {
    return (actions.equipmentOptionSubmitFinished(payload.response, action.orderId));
  }).catch(() => of(actions.equipmentOptionSubmitFailed(action.request, action.orderId))));






// WEBPACK FOOTER //
// ./src/epics/equipmentOptionsEpic.js